import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GraphService } from 'src/app/services/api/graph.service';

/* ─── Response types ─── */

export interface GetAllProviderResponse {
  id: string;
  nombre: string;
}

/* ─── Service ─── */

@Injectable({ providedIn: 'root' })
export class MassOsGenerationGraphqlApi {
  constructor(private readonly graphService: GraphService) {}

  getAllProviders(): Observable<GetAllProviderResponse[]> {
    return this.graphService
      .queryGraphQLSourcing<{ getSourcingProviders: GetAllProviderResponse[] }>({
        query: `query GetSourcingProviders {
          getSourcingProviders {
            id
            nombre
          }
        }`
      })
      .pipe(map((data) => data.getSourcingProviders ?? []));
  }

  getProgrammingItinerariesPage(input: any): Observable<any> {
    return this.graphService.queryGraphQLCore<any>({
      query: `query GetProgrammingItineraries($input: GetProgrammingItinerariesInput!) {
        getProgrammingItinerariesPage(input: $input) {
          nextCursor
          totalApprox
          items {
            id
            fileNumber
            nameClient
            displayState
            startDateFile
          }
        }
      }`,
      variables: { input }
    });
  }

  /** Página de itinerarios con los serviceIds de cada file. */
  getProgrammingServicesPage(input: any): Observable<any> {
    return this.graphService.queryGraphQLCore<any>({
      query: `query GetProgrammingServices($input: GetProgrammingServicesInput!) {
        getProgrammingServicesPage(input: $input) {
          nextCursor
          totalApprox
          items {
            id
            fileNumber
            nameClient
            displayState
            startDateFile
            serviceIds
          }
        }
      }`,
      variables: { input }
    });
  }

  /** Detalle de servicios por ids (con errores por id). */
  getProgrammingServicesByIds(serviceIds: string[]): Observable<any> {
    return this.graphService.queryGraphQLCore<any>({
      query: `query GetProgrammingServicesByIds($input: GetProgrammingServicesByIdsInput!) {
        getProgrammingServicesByIds(input: $input) {
          items {
            id
            nombreServicio
            tipoServicio
            startDateService
            day
            paxQuantity
            cantPersonal
            moneda
            total
            displayTypeService
            providerSnapshot {
              id
              nombre
              condicionesPagos {
                condicionPago
                plazoDiasFit
              }
            }
          }
          errors {
            serviceId
            code
            message
          }
        }
      }`,
      variables: { input: { serviceIds } }
    });
  }
}
